import { render, staticRenderFns } from "./Basf01.vue?vue&type=template&id=3a0cd259&scoped=true&"
import script from "./Basf01.vue?vue&type=script&lang=js&"
export * from "./Basf01.vue?vue&type=script&lang=js&"
import style0 from "./Basf01.vue?vue&type=style&index=0&id=3a0cd259&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0cd259",
  null
  
)

export default component.exports